module.exports = __webpack_public_path__ + "img/logo.56c12ca3.svg";